import script from "./DropdownEmpresas.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownEmpresas.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownEmpresas.vue?vue&type=style&index=0&id=760b71b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-760b71b2"]])

export default __exports__